import * as Sentry from "@sentry/vue";
import { router } from "@/router/index";
import type { App } from "vue";
export const initSentry = (app: App) => {
  Sentry.init({
    app,
    dsn: "https://435eef2427a8dcb68a1d940481eb91f8@getsentry-api.hellotalk8.com/12",
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          "localhost",
          /^https:\/\/yourserver\.io\/api/
        ],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router())
      }),
      new Sentry.Replay()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};
